import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ThemeService, Theme } from '../../services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss']
})
export class ThemeToggleComponent implements OnInit, OnDestroy {
  currentTheme: Theme = 'light';
  isDarkMode: boolean = false;
  isDropdownOpen: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    // Subscribe to theme changes
    this.subscription.add(
      this.themeService.currentTheme$.subscribe(theme => {
        this.currentTheme = theme;
        this.isDarkMode = this.themeService.isDarkMode();
      })
    );

    // Listen for system theme changes
    this.themeService.listenForSystemChanges();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Set specific theme
   */
  setTheme(theme: Theme): void {
    this.themeService.setTheme(theme);
    this.isDropdownOpen = false;
  }

  /**
   * Toggle dropdown
   */
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Close dropdown
   */
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  /**
   * Handle click outside to close dropdown
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.theme-dropdown')) {
      this.isDropdownOpen = false;
    }
  }

  /**
   * Get theme icon based on current theme
   */
  getThemeIcon(): string {
    switch (this.currentTheme) {
      case 'dark':
        return '🌙';
      case 'light':
        return '☀️';
      case 'system':
        return this.isDarkMode ? '🌙' : '☀️';
      default:
        return '☀️';
    }
  }

  /**
   * Get theme label
   */
  getThemeLabel(): string {
    switch (this.currentTheme) {
      case 'dark':
        return 'Dark Mode';
      case 'light':
        return 'Light Mode';
      case 'system':
        return 'System';
      default:
        return 'Light Mode';
    }
  }
}
